import * as React from 'react';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
import { Rahmenauftraege } from './Rahmenauftraege';

export const RahmenauftraegePrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const datumVon = urlSearchParams.get('datumVon') || moment().format('YYYY-MM-DD');
    const datumBis = urlSearchParams.get('datumBis') || moment().format('YYYY-MM-DD');

    const sortColumn = urlSearchParams.get('sortColumn') || 'groupByLabel';
    const sortDirection = urlSearchParams.get('sortDirection') === 'asc' ? 'asc' : 'desc';

    const betreuer = urlSearchParams.get('betreuer') ? parseInt(urlSearchParams.get('betreuer') || '0', 10) : undefined;
    const telBetreuer = urlSearchParams.get('telBetreuer')
        ? parseInt(urlSearchParams.get('telBetreuer') || '0', 10)
        : undefined;

    const berechnungsart = urlSearchParams.get('berechnungsart') === 'offen' ? 'offen' : 'abrufe';

    const excludeReclay = urlSearchParams.get('excludeReclay') === 'true';

    const status = urlSearchParams.get('status') ? parseInt(urlSearchParams.get('status') || '0', 10) : undefined;

    return (
        <Rahmenauftraege
            sortColumn={sortColumn}
            sortDirection={sortDirection}
            toggleSort={() => {}}
            datumVon={datumVon}
            datumBis={datumBis}
            betreuer={betreuer}
            telBetreuer={telBetreuer}
            status={status}
            berechnungsart={berechnungsart}
            excludeReclay={excludeReclay}
            printView
        />
    );
};
